// src/components/ListView/index.js

import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { list } from 'actions/data'
import { withStyles, Grid } from '@material-ui/core'
import List from './List'
import { toggleView } from 'actions/tasks'
import { search, toggleDialog, forceListUpdate } from 'actions/view'
import { DATA_API_URL } from 'utils/AllURLs'

export default connect(
  state => ({
    viewManuallySelected: state.tasks.viewManuallySelected,
  }),
  (dispatch, { listFn }) =>
    bindActionCreators(
      listFn
        ? { ...listFn, toggleView, toggleDialog, search, forceListUpdate }
        : { list, toggleView, toggleDialog, search, forceListUpdate },
      dispatch,
    ),
)(
  withStyles(theme => ({
    tasksPageGridMobileWidth: {
      [theme.breakpoints.down('xs')]: {
        marginTop: 0,
      },
      [theme.breakpoints.up('sm')]: {
        marginTop: 5,
      },
    },
    mobilePadding: {
      padding: 23,
      [theme.breakpoints.down('xs')]: {
        padding: '12px',
      },
    },
    title: {
      color: '#014c94',
      margin: 0,
      [theme.breakpoints.down('xs')]: {
        marginTop: 3,
        fontSize: 25,
      },
    },
    sideButton: {
      height: '36.5px',
      [theme.breakpoints.down('sm')]: {
        height: 32,
      },
    },
  }))(
    class ListView extends Component {
      state = {
        anchorEl: null,
        showBulkUploadStatus: false,
      }

      componentDidMount() {
        if (
          this.props.endpoint === 'task' &&
          this.props.viewManuallySelected === 'calendar'
        ) {
          this.props.toggleView('calendar')
        }

        if (this.props.listFn) {
          Object.keys(this.props.listFn).forEach(fn => {
            // this should be promisified but hopefully this is good enough for now:
            this.props[fn]()
            this.props.forceListUpdate()
          })
        } else {
          this.props.list(this.props.endpoint).then(() => {
            this.props
              .list(
                'userpin',
                null,
                `${DATA_API_URL}/userpin/username-entity?secondary_id=${this.props.endpoint}`,
              )
              .then(() => {
                this.props.forceListUpdate()
              })
          })
        }
      }

      componentWillUnmount() {
        this.props.search(null)
        this.props.toggleView('list')
        this.props.forceListUpdate()
      }

      handleClick = event => {
        this.setState({ anchorEl: event.currentTarget })
      }

      handleClose = () => {
        this.setState({ anchorEl: null })
      }

      render() {
        const { classes, endpoint, shortLabel, dataPanels } = this.props

        const DataPanels = dataPanels
          ? require(`./${shortLabel || endpoint}/DataPanels`).default
          : null

        const propsWithoutClasses = { ...this.props, classes: undefined }

        return (
          <div className={classes.mobilePadding}>
            <Grid
              className={classes.tasksPageGridMobileWidth}
              container
              spacing={16}
              style={{ marginTop: '0px' }}
            >
              {dataPanels ? (
                <Grid item xs={12}>
                  <DataPanels />
                </Grid>
              ) : null}
              <Grid item xs={12}>
                <List {...propsWithoutClasses} />
              </Grid>
            </Grid>
          </div>
        )
      }
    },
  ),
)
